const FORMSPREE_ENDPOINT = 'https://formspree.io/f/mzdwpgqo';

function formatValue(value) {
  if (Array.isArray(value)) {
    return value.length ? value.join(', ') : 'None';
  }
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }
  if (value === null || value === undefined) {
    return '';
  }
  return String(value);
}

function sanitizeFields(fields) {
  const payload = {};
  for (const [key, value] of Object.entries(fields)) {
    if (key === 'honeypot' || key === 'recaptchaToken') {
      continue;
    }
    const formatted = formatValue(value);
    if (formatted !== '') {
      payload[key] = formatted;
    }
  }
  return payload;
}

export async function submitToFormspree({ formType, subject, fields }) {
  const response = await fetch(FORMSPREE_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      _subject: subject,
      formType,
      ...sanitizeFields(fields),
    }),
  });

  let data = {};
  try {
    data = await response.json();
  } catch {
    // Formspree may return non-JSON on some errors
  }

  if (!response.ok) {
    const message =
      data.error ||
      (Array.isArray(data.errors) && data.errors.map((e) => e.message).join(', ')) ||
      'Something went wrong. Please try again.';
    throw new Error(message);
  }

  return data;
}

export const PREFERRED_TIME_LABELS = {
  morning: 'Morning (9AM - 12PM)',
  afternoon: 'Afternoon (12PM - 4PM)',
  evening: 'Evening (4PM - 7PM)',
};
